/**
 * @generated SignedSource<<32ac26c02287c06b2c35d1168211ce5e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProductStatus = "PUBLISHED" | "UN_PUBLISHED";
export type SetStatusProductInput = {
  productID: string;
  status: ProductStatus;
};
export type puSwitchProductSetStatusMutation$variables = {
  input: SetStatusProductInput;
};
export type puSwitchProductSetStatusMutation$data = {
  readonly setStatusProduct: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
    readonly model: {
      readonly id: string;
      readonly statusID: number;
    } | null;
  };
};
export type puSwitchProductSetStatusMutation = {
  response: puSwitchProductSetStatusMutation$data;
  variables: puSwitchProductSetStatusMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Model",
  "kind": "LinkedField",
  "name": "model",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "statusID",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "puSwitchProductSetStatusMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "SetStatusProductPayload",
        "kind": "LinkedField",
        "name": "setStatusProduct",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "puSwitchProductSetStatusMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "SetStatusProductPayload",
        "kind": "LinkedField",
        "name": "setStatusProduct",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "835cb5134e4f97d67f9a8449038cd42d",
    "id": null,
    "metadata": {},
    "name": "puSwitchProductSetStatusMutation",
    "operationKind": "mutation",
    "text": "mutation puSwitchProductSetStatusMutation(\n  $input: SetStatusProductInput!\n) {\n  setStatusProduct(input: $input) {\n    model {\n      id\n      statusID\n    }\n    errors {\n      __typename\n      ... on Error {\n        __isError: __typename\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "49970a303910614a79c05074eec59d73";

export default node;
